/**This function takes a phone number (+1xxxxxxxxxx, 1xxxxxxxxxx or xxxxxxxxxx) as input
 * and outputs (xxx) xxx-xxxx
 */

export default function formatPhoneNumber(number) {
  // Match numbers starting with +1, just +, or no prefix at all
  const match = number.match(/^(?:\+1|\+)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  } else {
    return number;
  }
}
